import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard/Dashboard";
import Projects from "@/components/Projects/Projects";
import Analytics from "@/components/Analytics/Analytics";
import Team from "@/components/Team/Team";
import Settings from "@/components/Settings/Settings";

Vue.use(VueRouter);

const routes = [
  { path: "/:company/login", component: Login },
  {
    path: "/:company",
    redirect: "/:company/dashboard"
  },
  {
    path: "/:company/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/:company/projects",
    name: "projects",
    component: Projects,
    meta: { requiresAuth: true }
  },
  {
    path: "/:company/analytics",
    name: "analytics",
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: "/:company/team",
    name: "team",
    component: Team,
    meta: { requiresAuth: true }
  },
  {
    path: "/:company/settings",
    name: "settings",
    component: Settings,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve(async (to, from, next) => {
  store.state.companyName = to.params.company;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
      next();
    } catch (e) {
      if (!to.fullPath.endsWith("/login")) {
        next({
          path: "/" + to.params.company + "/login"
        });
      }
    }
  }
  next();
});

export default router;
